export default __webpack_public_path__ + "static/media/anireka.91f44177.svg";